import { ActionsDropdown } from '~/components/ActionsDropdown';
import { Localized } from '~/i18n';
import { getTranslationKey } from './utils';
import { ApiConfigData, ApplicationTypeEnum } from '~/api';
import { mergeProps } from 'solid-js';

type MultiAppListItemActionsProps = {
  appData: ApiConfigData;
  deleteApplication: (appData: ApiConfigData) => void;
  editApplication: (appData: ApiConfigData) => void;
};

export default function MultiAppListItemActions(
  props: MultiAppListItemActionsProps
) {
  const merged = mergeProps({}, props);
  return (
    <ActionsDropdown
      id={`multi-app-table-row-actions`}
      items={[
        {
          label: <Localized translationKey={getTranslationKey('cta_edit')} />,
          onClick: () => merged.editApplication(merged.appData)
        },
        ...((merged.appData.clientType as ApplicationTypeEnum) !==
        ApplicationTypeEnum.DEFAULT_APPLICATION
          ? [
              {
                label: (
                  <span class="text-error">
                    <Localized
                      translationKey={getTranslationKey('cta_delete')}
                    />
                  </span>
                ),
                onClick: () => merged.deleteApplication(merged.appData)
              }
            ]
          : [])
      ]}
    />
  );
}
